import { Menu } from "react-feather";

interface MobileMenuButtonProps {
  onClick: () => void;
}

export default function MobileMenuButton({ onClick }: MobileMenuButtonProps) {
  return (
    <button
      onClick={onClick}
      className="md:hidden p-1 text-muted-foreground bg-card border border-border hover:border-border hover:text-foreground hover:bg-accent rounded-lg transition-colors"
      aria-label="Open menu"
    >
      <Menu className="w-6 h-6" />
    </button>
  );
}
